import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import DashBoard from './app/containers/_commons/DashBoard';
import Demo from './app/containers/_commons/Demo';

import {
  Video, VideoDetailContainer, VideoListContainer, BulkDeleter, OriginalUploader
} from '@containers/services/csmsmedia';

import SettingsMain from './app/containers/_settings/SettingsMain';

// VideoList and VideoDetail components are not exported from services
// Using VideoListContainer and VideoDetailContainer instead
import IBTUsage from '@containers/services/csmsibt/IBTUsage';






const Common = () => {


  return (
    <Routes>
      <Route path="/" element={<DashBoard />} />
      {
        /*
        <Route path="/:uuid/wave" element={<WaveSurferDemo />} />
          */
      }

      <Route path="settings" element={<SettingsMain />} />


      <Route path="/vod" element={<Video />}>
        <Route index element={<VideoListContainer />} />
        <Route path="list" element={<VideoListContainer />} />
        <Route path="bulkDeleter" element={<BulkDeleter />} />
        <Route path="originalVodUploader" element={<OriginalUploader />} />
        <Route path=":uuid" element={<VideoDetailContainer />}>
          <Route path="subtitle" element={<VideoDetailContainer />} />
          <Route path="subtitle/:lang" element={<VideoDetailContainer />} />
          <Route path="chapter" element={<VideoDetailContainer />} />
          <Route path="chapter/:lang" element={<VideoDetailContainer />} />
          <Route path="editor" element={<VideoDetailContainer />} />
          <Route path="editor/:edit_id" element={<VideoDetailContainer />} />
          <Route path="infocard" element={<VideoDetailContainer />} />
        </Route>
      </Route>

      <Route path="/iam" element={<Video />}>

      </Route> {/* END IAM */}

      <Route path="/agora" element={<Video />}>
      </Route> {/* END agora */}

      <Route path="/cloudtracker" element={<Video />}>
      </Route> {/* END CloudTracker */}

      <Route path="/csmsdoc" element={<Demo />}>
        <Route index element={<Demo />} />
        <Route path="usage" element={<Demo />} />
      </Route> {/* END CSMSDoc */}

      <Route path="/csmsibt/usage" element={<IBTUsage />}>
        <Route path=':quiz_id' element={<IBTUsage />} />
      </Route> {/* END IBT */}

      <Route path="/meet" element={<Video />}>
      </Route> {/* END MEET */}

      <Route path="/page" element={<Video />}>
        <Route index element={<Video />} />
      </Route> {/* END PAGE */}

      <Route path="/watchtower" element={<Video />}>
      </Route> {/* WatchTower */}
    </Routes >
  );
}

export default Common; 